import { object, string } from "zod";

export const createReviewDiscountSchema = {
  input: object({
    teamId: string(),
    orderId: string(),
    reviewId: string(),
  }),
  output: object({
    discountCode: string(),
  }),
};
